import { Route, Routes } from "react-router-dom";
import Footer from "./components/Common/Footer";
import Navbar from "./components/Common/Navbar";
import Homepage from "./components/HomePage/Home";
import "./components/Common/Common.css";

import ArchivesMain from "./components/Archives/ArchivesMain";
import InsertForm from "./components/Archives/Form/InsertForm";
import AboutUs from "./components/AboutUs/About";

// import "./App.css";

const App = () => {
  return (
    <div className="entireApp">
      <header className="header">
        <title>Current Archives and Collections Index</title>
        <link rel="preconnect" href="https://fonts.googleapis.com"></link>
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        ></link>
        <link
          href="https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&display=swap"
          rel="stylesheet"
        ></link>
      </header>
      <Navbar />
      <Routes>
        {/* <Route path="/" element={<Homepage />} /> */}
        <Route path="/" element={<ArchivesMain />} />
        <Route path="/archives" element={<ArchivesMain />} />
        <Route path="/collection/:id" element={<ArchivesMain />} />
        <Route path="/insert-form" element={<InsertForm />} />
        <Route path="/about" element={<AboutUs />} />
      </Routes>
      <Footer />
    </div>
  );
};

export default App;
